import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import DropZone from 'components/Shared/DropZone';


import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';


import ArticleGestionSearch from 'components/Shared/ArticleGestionSearch';
import { TypeActionCodes, ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';

const styles = (theme) => ({
    detailValue: {
        paddingLeft: theme.spacing(4)
    },

    input: {
        marginTop: 10
    },
    formControl: {
        margin: 0,
        width: '100%'
    },
    heightLabel: {
        height: '30px'
    }
});

class DemandeInformationsAcheteurDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tr: 'false',
            codeTr: 'TR',
            codeArticle: '',
            destinataires: '',
            question: '',
            fichiersIds: []
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData = (newState) => {

        let { informations } = this.props;
               
        let actionData = null;


        if (!newState.destinataires || newState.destinataires === '') {
            return null;
        }

        if (!newState.question || newState.question === '') {
            return null;
        }
        

        if (newState.tr === 'true') {

            if (newState.codeTr === '' || newState.codeTr === 'TR') {
                return null;
            }

            actionData = {
                code: TypeActionCodes.Question,
                details: [{
                    code: ReclamationActionDetailCodes.Question,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Question :',
                    position: 0,
                    valeurString: `Demande d'information sur le code TR ${newState.codeTr}.\n`
                        + newState.question
                }],
                reponseAttendue: true
            };
        } else {


            if (newState.codeArticle === '') {
                return null;
            }

            if (!informations.codeArticle) {
                return null;
            }

            actionData = {
                code: TypeActionCodes.Question,
                details: [{
                    code: ReclamationActionDetailCodes.Question,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Question :',
                    position: 0,
                    valeurString: `Demande d'information sur l'article ${informations.codeArticle} (${informations.libelle}).\n`
                        + `Fournisseur : ${informations.codeFournisseur !== null ? informations.codeFournisseur : ''} - ${informations.referenceFournisseur !== null ? informations.referenceFournisseur : ''}.\n`
                        + `Prix d'achat : ${informations.tarifAchat !== undefined && informations.tarifAchat !== null ? informations.tarifAchat : 0} €.\n`
                        + newState.question
                }]
            };
        }

        actionData.details.push({
            code: ReclamationActionDetailCodes.Email,
            type: ReclamationActionDetailType.Texte,
            libelle: 'Email(s) destinataire(s)',
            position: 1,
            valeurString: newState.destinataires
        });

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const actionData = this.getActionData(newState);

        this.props.onChange(actionData);

    }

    handleChangeArticleGestion = async (suggestion) => {

        const newState = {
            ...this.state,
            codeArticle: '',
            destinataires: ''
        };

        if (suggestion && suggestion.reference && suggestion.reference !== '') {
            await this.props.fetchInformations(suggestion.reference);

            newState.codeArticle = suggestion.reference;
            newState.destinataires = this.props.informations.contacts;
        }


        this.setState(newState);

        const actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }

    handleChangeTr = (event) =>
    {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (newState.tr === 'true' && this.state.tr === 'false') {
            newState.destinataires = this.props.emailPO;
        }


        this.setState(newState);

        const actionData = this.getActionData(newState);

        this.props.onChange(actionData);
    }


    render() {
        let { classes, informations } = this.props;
        let { codeArticle, question, tr, codeTr } = this.state;

        return (
            <DialogContent>
                <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                <Typography variant="body2" gutterBottom className={classes.detailValue}>Créer une question</Typography>



                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">S'agit-il d'un TR ?</FormLabel>
                    <RadioGroup
                        id="tr"
                        name="tr"
                        className={classes.group}
                        value={tr}
                        onChange={this.handleChangeTr}
                    >
                        <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                        <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>


                {tr === 'true' &&
                    <React.Fragment>

                        <TextField className={classes.formControl}
                            id="codeTr"
                            name="codeTr"
                            label="Code TR"
                            placeholder="Code TR"
                            margin="normal"
                            value={codeTr}
                            onChange={this.handleChange}
                        />


                        <TextField className={classes.formControl}
                            id="question"
                            name="question"
                            label="Question"
                            placeholder="Question"
                            multiline
                            margin="normal"
                            value={question}
                            onChange={this.handleChange}
                        />
                        <TextField className={classes.input} id="destinataires" name="destinataires" label='Destinataires du mail (séparé par un ";")' type="text" value={this.state.destinataires} onChange={this.handleChange} fullWidth />

                     </React.Fragment>
                }

                {tr==='false' &&
                    <React.Fragment>
                        <ArticleGestionSearch namespace="addAction" onChange={this.handleChangeArticleGestion} isRequired infosLogistique={false}/>

                        {codeArticle && (
                            <React.Fragment>
                                <Typography variant="body1" gutterBottom className={classes.input}>Informations :</Typography>
                                <Typography variant="body2" gutterBottom className={classes.detailValue}>Article : {informations.codeArticle} - {informations.libelle}</Typography>
                                <Typography variant="body2" gutterBottom className={classes.detailValue}>Fournisseur : {informations.codeFournisseur} - {informations.referenceFournisseur}</Typography>
                                <Typography variant="body2" gutterBottom className={classes.detailValue}>{`Prix d'achat : ${informations.prixAchat} €`}</Typography>


                                <TextField className={classes.formControl}
                                    id="question"
                                    name="question"
                                    label="Question"
                                    placeholder="Question"
                                    multiline
                                    margin="normal"
                                    value={question}
                                    onChange={this.handleChange}
                                />

                                <TextField className={classes.input}
                                    id="destinataires"
                                    name="destinataires"
                                    label='Destinataires du mail (séparé par un ";")'
                                    placeholder='Destinataires du mail (séparé par un ";")'
                                    type="text"
                                    value={this.state.destinataires}
                                    onChange={this.handleChange}
                                    fullWidth
                                />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                }

                <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />

            </DialogContent>
        );
    }
}

DemandeInformationsAcheteurDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    fetchInformations: PropTypes.func.isRequired,
    informations: PropTypes.object,
    emailPO: PropTypes.string
};

export default withStyles(styles)(DemandeInformationsAcheteurDialogContent);